<script setup lang="ts">
import {computed} from "vue";
import useSwr from "@/core/composables/swr/useSwr";
import {cacheKey} from "@/lib/cache";
import {useRouter} from "vue-router";
import {flowchartApi} from "@/container";
import {Flowchart} from "@/core/interfaces/flowchart/flowchart";

const router = useRouter();

const headers = [
    {
        title: "Nom",
        key: "name"
    },
    {
        title: "Description",
        key: "description",
    },
];
/**
 * Fetches fraud reports from the ASAFO API.
 * Uses SWR for data fetching and caching.
 */
const {data, isValidating} = useSwr(
    computed(() => cacheKey("flowcharts")),
    () => flowchartApi().index(),
);

/**
 * Navigates to the reports page for a specific patient.
 * @param _event  The mouse event.
 * @param row The row data containing the flowchart item.
 */
const showFlowchart = (_event: MouseEvent, row: { item: Flowchart }) => {
    router.push({name: 'flowcharts.show', params: {id: row.item.id}});
};
</script>

<template>
  <v-data-table-server
    disable-sort
    return-object
    :headers="headers"
    :loading="isValidating"
    :items="data"
    :items-length="data?.length || 0"
    :items-per-page-options="[10, 20, 50, 100]"
    @click:row="showFlowchart"
  />
</template>
